/** @jsx jsx */
import { jsx } from "@emotion/core"
import PropTypes from "prop-types"
import { dateContainerStyle, inputStyles } from "./styles"
import { DatePicker } from "antd"

/**
- Standard date-picker component for accepting textual user date-picker.
- Based on top of Antd [date-picker](https://ant.design/components/date-picker/), This component accepts all of antd date-picker props and more.
**/
export const Date = (props) => {
  const { error, icon, ...rest } = props
  return (
    <div className="Date-container" css={dateContainerStyle}>
      <DatePicker
        css={inputStyles(error, icon)}
        {...rest}
        dateRender={(current) => {
          const style = {}
          return (
            <div className="ant-picker-cell-inner" style={style}>
              {current.date()}
            </div>
          )
        }}
      />
      {error && <span className="error-text">{error}</span>}
    </div>
  )
}
Date.propTypes = {
  /** Apart from all standard date-picker [props](https://ant.design/components/date-picker/), this component accepts -  */
  /** error string, only to be passed if date-picker is in error state. */
  error: PropTypes.string,
  /** icon required or not */
  icon: PropTypes.string,
}

Date.defaultProps = {
  error: "",
  icon: "",
}
